"use client";

import { useEffect } from "react";
import type { Id } from "@convex/_generated/dataModel";
import { track } from "@/lib/analytics/tracker";
import { buildGA4Item } from "@/lib/analytics/ga4/items";
import { trackGA4ViewItem } from "@/lib/analytics/ga4/ecommerce";
import { trackActivationCompleted } from "@/lib/analytics/onboarding-flow";

interface ListingViewTrackerProps {
  productId: Id<"products">;
  productType?: string;
  slug: string;
  title?: string;
  priceCents?: number;
  productCategory?: string;
  publicIdentifier?: string;
  condition?: string;
}

export function ListingViewTracker({
  productId,
  productType,
  slug,
  title,
  priceCents,
  productCategory,
  publicIdentifier,
  condition,
}: ListingViewTrackerProps) {
  useEffect(() => {
    track("listing.viewed", { productId, productType, slug });
    trackActivationCompleted("listing.viewed");

    if (title) {
      const item = buildGA4Item({
        itemId: publicIdentifier ?? productId,
        itemName: title,
        priceCents,
        category: productCategory,
        variant: condition,
        quantity: 1,
      });
      const value = priceCents != null ? Math.round(priceCents) / 100 : 0;
      trackGA4ViewItem(item, value);
    }
  }, [
    productId,
    productType,
    slug,
    title,
    priceCents,
    productCategory,
    publicIdentifier,
    condition,
  ]);

  return null;
}
